import { render } from "./myheader_white.vue?vue&type=template&id=6aeae8ab&scoped=true"
import script from "./myheader_white.vue?vue&type=script&lang=js"
export * from "./myheader_white.vue?vue&type=script&lang=js"

import "./myheader_white.vue?vue&type=style&index=0&id=6aeae8ab&scoped=true&lang=less"

import exportComponent from "D:\\Develop\\项目\\机电集团官网\\custom-website-desk\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aeae8ab"]])

export default __exports__